import { render, staticRenderFns } from "./LimitTag.vue?vue&type=template&id=a9a79e0a&"
import script from "./LimitTag.vue?vue&type=script&lang=js&"
export * from "./LimitTag.vue?vue&type=script&lang=js&"
import style0 from "./LimitTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
